<div class="geo-container" style="overflow:hidden;">
	<!-- Header Controls -->
	<div class="navbar navbar-default">
	  <div class="container-fluid">
	     <!-- Feature table pagination -->
	     <div class="btn-group" *ngIf="viewType === 'arcgis' && (arcgis.type === 'geojson' || arcgis.type === 'featureserver')">
        	<div class="col-xs-2">
	            <button class="btn btn-sm btn-primary" (click)="toggleFeatures()">
	                {{LOCALIZATION.features}}
	                <i class="fa fa-caret-down" [hidden]="!featuresToggled" aria-hidden="true"></i>
	                <i class="fa fa-caret-up" [hidden]="featuresToggled" aria-hidden="true"></i>
	            </button>
            </div>
            <div [hidden]="gridData.length == 0" class="col-xs-10">
                <div class="btn-group dropup pull-left hide-xs" ngbDropdown>
                    <button id="pagesizeButton" type="button" class="btn btn-primary btn-sm" ngbDropdownToggle title="Toggle for page size dropdown">
                        {{LOCALIZATION.showing}} <span class="badge">{{arcgis.pagination.num_per_page}}</span> <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" ngbDropdownMenu role="menu" aria-labelledby="pagesizeButton">
                        <li role="menuitem" (click)="pageSizeChanged(pagesize)" *ngFor="let pagesize of arcgis.pagination.pagesize">
                            <a>{{pagesize}}</a>
                        </li>
                    </ul>
                </div>
                <div class="pull-left">
					<ngb-pagination 
						class="pagination pagination-sm custom-page nomargins"
						style="display:inline-block;"
						[(page)]="arcgis.pagination.page" 
						[pageSize]="arcgis.pagination.num_per_page"
						[collectionSize]="arcgis.pagination.total"
						(pageChange)="arcgis.pageChanged($event)"
						[maxSize]="5"
						[boundaryLinks]="true" 
						[ellipses]="false"
						previousText="&#xf053;" 
						nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">						
					</ngb-pagination>
                </div>
                <div class="pull-left" *ngIf="loading === 'DONE'">
                    <h5>{{(arcgis.pagination.num_per_page * (arcgis.pagination.page-1))+1}}-{{(arcgis.pagination.num_per_page * (arcgis.pagination.page-1)) + gridData.length}} of {{arcgis.pagination.total}}</h5>
                </div>
            </div>
        </div>
        
        <!-- Projection tooling -->
		<div class="btn-group" *ngIf="viewType === 'map'" style="padding: 6px 12px;">
		  <!-- Toggle Projection Checkbox -->
		  <div class="pull-left" style="margin-right: 15px;">
		    <label class="control control--checkbox" style="margin: 0; display: inline-flex; align-items: center;">
		      <input type="checkbox" [(ngModel)]="projectionvisible" (click)="toggleProjection()" />
		      <div class="control__indicator" style="margin-right: 6px;"></div>
		      <span title="Toggle projection" style="font-size: 14px; font-weight: 400;">
		        {{LOCALIZATION.toggleProjection}}
		      </span>
		    </label>
		  </div>
		  <!-- Background Opacity Slider -->
		  <div class="pull-left" style="margin-top: 2px;">
		    <label style="font-size: 14px; font-weight: 400; margin-right: 5px;">
		      {{LOCALIZATION.backgroundOpacity}}:
		    </label>
		    <input type="range"
		           [(ngModel)]="opacity"
		           min="0"
		           max="1"
		           step="0.1"
		           (change)="toggleOpacity()"
		           style="vertical-align: middle; width: 120px;" />
		  </div>
		</div>
	    
        <div class="btn-group" class="pull-right" *ngIf="viewType === 'map'">
		  <!--  Returns to the original GEOPDF or GEOTIFF viewer. See KV-2930 -->
	      <button class="btn btn-default btn-sm navbar-btn" (click)="exitProjection()" title="{{LOCALIZATION.returnToDocView}}">
	        <i class="fa fa-eye-slash"></i>
	      </button>
        </div>
	  </div>
	</div>
	
	<!-- Content -->
	<!-- Height is calculated by subtracting the navbar height -->
	<div class="geoViewerFocus" style="width:100%; height:calc(100% - 52px); margin-top:0;">
        <div id="esri-map-container" class='panel-body'>
            <div id='MapNorthArrow'>
                <img [src]="'/app/aw-ui-angular/assets/img/cosd_north_arrow.webp'" style="height:45px;">
            </div>
            <div style="position:absolute; top:20px; left:80px; z-index:1000; background-color:white; padding:1em; border-radius:2px;">
				<select [(ngModel)]="mapControl.baseMapUnit"
						name="basemap"
				        (click)="changeBasemap()">
					<option *ngFor="let basemap of basemapConfigs" [ngValue]="basemap.name">
				    	{{ basemap.displayName }}
				  	</option>
				</select>
            </div>
              
              
            <div #mapContainer id="arcgis-layer-div" style="height:100%; margin:0; padding:0;"></div>
            
            
        </div>
    </div>
    <div id="arcgis_feature_table"
    	*ngIf="arcgis.type === 'geojson' || arcgis.type === 'featureserver'" 
    	class="background-white"
    	[ngStyle]="{ visibility: featuresToggled ? 'visible' : 'hidden' }"
    	style='width:100%; position:absolute; bottom:0px; height:500px; z-index:10;'>
    	
		<span *ngIf="loading === 'PENDING'"><i class="fa fa-circle-o-notch fa-spin text-grey fa-fw full-center fa-3x"></i></span>
		
		<!-- Features Grid -->
		<div style="overflow-x:auto; overflow-y:hidden;">
		      <ag-grid-angular #kvGrid
		        style="width: 100%; height: 450px;"
		        [gridOptions]="gridOptions"
		        [rowData]="gridData"
		        [columnDefs]="columns"
		        [defaultColDef]="defaultColDef"
		        [pagination]="false"
		      />
		</div>
	</div>
	
    <div *ngIf="loading === 'ERROR'" class="text-center">
        <div class="full-center"><h3>{{LOCALIZATION.viewerDocumentError}}</h3></div>
    </div> 	
</div>
